import { useFlags } from '@atlaskit/flag';
import { AddLocationFormFields } from 'core/config/form-fields';
import { useDialog } from 'core/providers/DialogProvider';
import { showErrorFlag, showSuccessFlag } from 'core/utilities/flags-helper';
import { useState } from 'react';
import { IButton } from 'shared/components/buttons/button-interface';
import SharedDialogBase from 'shared/components/dialog-base/dialog-base';
import SharedForm from 'shared/components/form/form';
import { LocationsApiService } from 'core/api';
import { useAuthState } from 'core/providers/AuthProvider';
import { ILocationDao } from 'core/api/types';
import { ISharedFormField } from 'shared/components/form/form-interface';

const UpdateLocationDialog = ({ location }: { location: ILocationDao }) => {
  const { userData } = useAuthState();
  const flags = useFlags();
  const dialog = useDialog();

  const [formSubmitting, setFormSubmitting] = useState(false);

  const updateLocation = async (data: ILocationDao) => {
    setFormSubmitting(true);
    try {
      await LocationsApiService.update(
        location.uid,
        {
          active: data.active,
          name: data.name,
          emailAddress: data.emailAddress,
          address: data.address,
          phoneNumber: data.phoneNumber,
        },
        {
          fullName: userData?.fullName ?? '',
          uid: userData?.uid ?? '',
        }
      );
      showSuccessFlag('Location created', 'The location has been updated successfully', flags);
      dialog?.closeDialog();
    } catch (error) {
      showErrorFlag('Location update failed', `Unable to update the location, please try again.`, flags);
      setFormSubmitting(false);
    }
  };

  const cancelButton: IButton = {
    onClick: () => dialog?.closeDialog(),
    label: 'Cancel',
    appearance: 'subtle',
    type: 'button',
  };

  const updateLocationFormFields = AddLocationFormFields.map((field) => ({
    ...field,
    defaultValue: location[field.key as keyof ILocationDao],
  }));

  const customContent = () => {
    return (
      <SharedForm
        className='p-4 overflow-y-auto'
        onSubmit={updateLocation}
        fields={updateLocationFormFields as ISharedFormField[]}
        buttonLabel='Submit'
        loading={formSubmitting}
        cancelButton={cancelButton}
      />
    );
  };

  return <SharedDialogBase title='Update location' customContentTemplate={customContent()} showButtons={false} />;
};

export default UpdateLocationDialog;
